import { Injectable } from "@angular/core";
import { Store, StoreConfig } from "@datorama/akita";
import { UserInfo } from "../api/gmi/auth/models/user-info.model";
import { InfoModel } from "../api/gmi/info/models/info.model";

export interface AppState {
    serverState: InfoModel | null;
    currentUser: UserInfo | null;
}

export function createInitialState(): AppState {
    return {
        serverState: null,
        currentUser: null
    };
}

@Injectable()
@StoreConfig({ name: "app" })
export class AppStore extends Store<AppState> {
    constructor() {
        super(createInitialState());
    }
}
